module.exports = __webpack_public_path__ + "static/media/lock_inactive.0b6b1d20.svg";